import React from "react";

const CalendarSideDetails = ({ totalByMonth, getMonthName, t }) => {
  return (
    <div className="total_amount_wrap" style={{ overflow: "scroll" }}>
      {totalByMonth?.map(({ monthYear, totalHours, totalAmount }) => (
        <div
          key={monthYear}
          className="ml-3 mb-2 total_amount"
          style={{
            border: "1px solid gray",
            borderRadius: "10px",
            padding: "8px",
          }}
        >
          <h6>
            <span className="font-weight-bold" style={{ fontSize: "14px" }}>
              {t("Total hours in")} {t(getMonthName(monthYear)?.split(" ")[0])}{" "}
              {t(getMonthName(monthYear)?.split(" ")[1])}:{" "}
            </span>
            <span className="mt-2" style={{ fontSize: "14px" }}>
              {totalHours || 0}
            </span>
          </h6>
          <div>
            <h6>
              <span className="font-weight-bold" style={{ fontSize: "14px" }}>
                {t("Total amount in")}{" "}
                {t(getMonthName(monthYear)?.split(" ")[0])}{" "}
                {t(getMonthName(monthYear)?.split(" ")[1])}:{" "}
              </span>
              <span style={{ fontSize: "14px" }}>
                {Number(totalAmount)?.toFixed(2) || 0}
              </span>
            </h6>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CalendarSideDetails;
